import 'whatwg-fetch';

import { SIMPLE, NO_CONTENT } from './constants';

function callApi (endpoint, headers = {}, method = 'GET', body = '') {
  const options = {
    credentials: 'include',
    method,
    headers
  };
  if (body && !["GET", "HEAD"].includes(method)) {
    options.body = JSON.stringify(body);
  }
  return fetch(endpoint, options).then((response) => {
    /* 
      Different fetch implementations handle parsing JSON of a 204 response
      differently, so here we specifically catch the No Content/Empty response and
      return a resolved promise.
    */
    const { status } = response;
    
    if (response.status === NO_CONTENT || !response.bodyUsed) {
      return Promise.resolve({ status });
    }
    return response.json().then((json) => {
      if (!response.ok) {
        return Promise.reject({ json, status });
      }
      return { json, status };
    });
  });
}

function createSimpleAPIMiddleware(processBody) {
  return ({ dispatch, getState }) => next => action => {
    const request = action[SIMPLE];

    if (typeof request === 'undefined') {
      return next(action);
    }

    const { payload = {}, endpoint, types, context, method, body, headers } = request;

    const [requestType, successType, failureType] = types;

    const actionWith = (data) => {
      const finalAction = { ...action, ...data };
    
      if (context) {
        finalAction.context = context;
      }
      delete finalAction[SIMPLE];
      return finalAction;
    };

    if (requestType) {
      next(actionWith({ type: requestType, payload }));
    }

    const getBody = () => {
      if(typeof processBody === 'function') {
        return processBody(request, getState);
      }
      return body;
    }

    return callApi(endpoint, headers, method, getBody()).then(
      response => next(actionWith({
        response: response.json,
        status: response.status,
        type: successType,
        payload
      })),
      error => next(actionWith({
        status: error.status,
        type: failureType,
        error: error.json || error.title || error.message || 'Unexpected Error',
        payload
      }))
    );
  };
}

const simpleAPIMiddleware = createSimpleAPIMiddleware();

export default simpleAPIMiddleware;
export { createSimpleAPIMiddleware };



// WEBPACK FOOTER //
// ./node_modules/@localytics/redux-simple-api-middleware/lib/simpleAPI.js